export class CarouselItem {
	altText: string;
	link: string;
	image: string;
	order: number;

	constructor(item) {
		this.altText = item.altText;
		this.link = item.hyperlinkUrl;
		this.order = item.orderNumber;
		this.image = item.imageData
			? `data:image/png;base64,${item.imageData}`
			: null;
	}
}